module.exports = __webpack_public_path__ + "img/addTeacher.8e73d355.svg";